import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { HealthCardModule, getHealthCardModuleTitle } from '@estercare/ester-shared'
import { useGetHealthPlanCardsQuery } from '../api/ester-b2b-api/private/healthPlan/healthPlanQueries'
import { useGetAssetById } from '../api/contentful/contentfulQueries'
import { useSelectUserLanguage } from '../state/selectors'
import { getHealthCardModuleImageId, DEFAULT_MODULE_IMAGE } from '../utils/imageMapper'
import { parseContenfulImageUrl } from '../contentful/utils'
import { theme } from '../theme/theme'
import { Title6 } from './styles/Typography'
import { ComponentLayout } from './layouts/ComponentLayout'

const ModuleCircle = ({ module }: { module: HealthCardModule }) => {
  const language = useSelectUserLanguage()
  const navigate = useNavigate()
  const { data: imageAsset } = useGetAssetById(getHealthCardModuleImageId(module))

  const title = language ? getHealthCardModuleTitle(module, language) : module
  const imageUrl = imageAsset ? parseContenfulImageUrl(imageAsset, { width: 200, height: 200 }) : DEFAULT_MODULE_IMAGE

  return (
    <CircleItem onClick={() => navigate(`/portal/your-health/health-plan?module=${module}`)}>
      <CircleImageWrapper>
        <CircleImage src={imageUrl} alt={title} />
      </CircleImageWrapper>
      <Title6>{title}</Title6>
    </CircleItem>
  )
}

export const HealthPlanCircles = () => {
  const { t } = useTranslation()
  const { data: healthPlanCards } = useGetHealthPlanCardsQuery()

  if (!healthPlanCards || healthPlanCards.length === 0) return null

  return (
    <ComponentLayout paddingBottom={0} paddingTop={theme.spacing.xxlarge}>
      <Title6>{t('employee.home.healthPlanTitle')}</Title6>
      <CirclesGrid>
        {healthPlanCards.map((card) => (
          <ModuleCircle key={card.module} module={card.module} />
        ))}
      </CirclesGrid>
    </ComponentLayout>
  )
}

const CirclesGrid = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small}px;
  margin-top: ${theme.spacing.large}px;
  overflow-x: auto;
`

const CircleItem = styled.button`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`

const CircleImageWrapper = styled.div`
  width: 170px;
  height: 170px;
  border-radius: 50%;
  overflow: hidden;
`

const CircleImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
